import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { Id, MunicipalEntitiesService } from '@prodcard/core'
import { VMunicipalEntitiesSelect } from '../../../../components'

export interface SearchParams {
  search: string
  municipalEntityId?: Id
}

interface Props {
  municipalEntitiesService: MunicipalEntitiesService
  defaultSearchParams: SearchParams
  loading?: boolean
  readonlyMe?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBox',
  props: {
    municipalEntitiesService: {},
    defaultSearchParams: {},
    loading: { type: Boolean, default: false },
    readonlyMe: { type: Boolean, default: false }
  },
  emits: ['update'],
  setup(__props: any, { emit }) {

const props = __props;




const searchParams = ref({
  search: props.defaultSearchParams.search,
  municipalEntityId: props.defaultSearchParams.municipalEntityId,
})

const update = (e: Event, reset?: boolean) => {
  if (reset) {
    Object.assign(searchParams.value, {
      search: undefined,
      municipalEntityId: props.readonlyMe ? searchParams.value.municipalEntityId : undefined,
    })
  }
  emit('update', searchParams.value)
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: _ctx.readonlyMe ? 12 : 7
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: searchParams.value.search,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.search) = $event)),
                    label: "Поиск по адресу",
                    "prepend-inner-icon": "mdi-magnify",
                    density: "comfortable",
                    onKeyup: _withKeys(update, ["enter"])
                  }, null, 8, ["modelValue", "onKeyup"])
                ]),
                _: 1
              }, 8, ["cols"]),
              (!_ctx.readonlyMe)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "5"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(VMunicipalEntitiesSelect), {
                        modelValue: searchParams.value.municipalEntityId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.municipalEntityId) = $event)),
                        "municipal-entities-service": _ctx.municipalEntitiesService,
                        readonly: _ctx.readonlyMe,
                        density: "comfortable"
                      }, null, 8, ["modelValue", "municipal-entities-service", "readonly"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "text",
            icon: "mdi-magnify",
            onClick: update,
            loading: _ctx.loading
          }, null, 8, ["loading"]),
          _createVNode(_component_v_btn, {
            variant: "text",
            icon: "mdi-restore",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (update($event, true))),
            disabled: _ctx.loading
          }, null, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})